import React from 'react';

import { formatDateForInput } from '../../../lib/utils';

export default class DateRangePicker extends React.Component {

    onChange(event) {
        this.props.update(event.target.name, event.target.value);
    }

    render() {
        
        const {startDate, endDate} = this.props;

        return (
            <div className="flex-center transaction-date-range">
                <p className="medium-text">Date Range</p>
                <input type="date" name="startDate" value={formatDateForInput(startDate)} max={endDate} onChange={this.onChange.bind(this)} />
                <p className="medium-text">To</p>
                <input type="date" name="endDate" value={formatDateForInput(endDate)} min={startDate} onChange={this.onChange.bind(this)} />
            </div>
        );
    }

}




// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/DateRangePicker.jsx